
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/ueberuns-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="ueberuns-view">
        <hero-section class="small"
            background-image="/images/ueberuns-hero.jpg"
            headline="Über Uns"
            text="zuverlässig, professionell und mit Leidenschaft."
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            
        </div>
    </section>`,
      style: `ueberuns-view .ueberuns-view {
  margin: 0;
  padding: 0;
}
ueberuns-view .ueberuns-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
ueberuns-view .ueberuns-view .wrapper article {
  margin: 0 0 32px 0;
  padding: 0;
}
ueberuns-view .ueberuns-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
@media (max-width: 992px) {
  ueberuns-view .ueberuns-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  